import { render, staticRenderFns } from "./medical-buy.vue?vue&type=template&id=1b352742&scoped=true"
import script from "./medical-buy.vue?vue&type=script&lang=ts"
export * from "./medical-buy.vue?vue&type=script&lang=ts"
import style0 from "./medical-buy.vue?vue&type=style&index=0&id=1b352742&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b352742",
  null
  
)

export default component.exports